export default __webpack_public_path__ + "static/content3-e715b2310987f748ff054b8e8a78b876.png";